import { useMutation } from "react-query";
import { doc, updateDoc } from "firebase/firestore";
import { Game, Member } from "./Game";
import { useSelector } from "../../../redux/store";
import { firestore } from "../../../utils/firebase/setupFirebase";
import sortBy from "lodash/sortBy";

export const useSetNextPlayerMutation = () => {
  const game = useSelector((state) => state.game.game);
  const gameRefUrl = useSelector((state) => state.game.gameRefUrl);
  const gameRef = doc(firestore, gameRefUrl!);

  return useMutation(async () => {
    const updateObject: Record<string, any> = {
      activePlayerId: getNextPlayerUserId(game!),
    };

    await updateDoc(gameRef, updateObject);
  });
};

export const getNextPlayerUserId = (game: Game) => {
  const members = sortBy<Member>(
    Object.values(game!.membersMap).filter((member) => !member.solved),
    "userId"
  );

  const findIndexOfActive = members.findIndex(
    (member: Member) => member.userId === game!.activePlayerId
  );

  const nextMember = members[(findIndexOfActive + 1) % members.length];

  return nextMember.userId;
};
